import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  btn: {
    marginBottom: theme.spacing(4),
    '&.--disabled': {
      cursor: 'not-allowed',
      backgroundColor: '#E0E0E0 !important',
      color: 'rgba(0, 0, 0, 0.32)',
      borderColor: '#E0E0E0',
    },
  },
  faqText: {
    width: '100%',
    maxWidth: 345,
    fontSize: 14,
    color: '#546E7A',
  },
  faqLink: {
    textDecoration: 'underline',
    color: '#072D83',
  },
}));
